import { getRequest } from '../utils'

export const getPositionGrouping: RequestTypeVariable = {
  getKey: (id: string, type: PositionGroupingType) => ['getPositionGrouping', id, type],
  request: async (
    projectId,
    type: PositionGroupingType,
  ): Promise<MemberPositionBundle[] | null> => {
    const { data } = await getRequest<MemberPositionBundle[]>({
      url: `/projects/${projectId}/position-grouping/${type}`,
    })

    return data
  },
}
